// src/lib/stompClient.js
// STOMP 클라이언트를 생성하는 모듈 (JWT 토큰 포함)

import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

/**
 * STOMP 클라이언트 인스턴스를 생성합니다.
 * @param {{ brokerURL?: string, token?: string, onConnect?: Function, onDisconnect?: Function, onStompError?: Function, onWebSocketError?: Function, onWebSocketClose?: Function }} options
 * @returns {Client}
 */
export function createStompClient({
  brokerURL = '/api/v1/messages/ws',
  token,
  onConnect,
  onDisconnect,
  onStompError,
  onWebSocketError,
  onWebSocketClose,
} = {}) {
  const client = new Client({
    // SockJS 엔드포인트 사용
    webSocketFactory: () => new SockJS(brokerURL),

    // CONNECT 헤더에 토큰 포함
    connectHeaders: token
      ? { Authorization: `Bearer ${token}` }
      : {},

    reconnectDelay: 15000,   // 재연결 간격 5s → 15s (로그 spam 감소)
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
    onConnect,
    onDisconnect,
    onStompError,
    onWebSocketError,
    onWebSocketClose,
  });

  return client;
}
